module.exports = __webpack_public_path__ + "img/member-new-2.fda07ed3.png";